import rgba from 'color-rgba';

const isColorLight = (color) => {
  if (!color || color == 'transparent') return 'light';

  const [r, g, b, a] = rgba(color);
	const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

	return (yiq >= 128);
}

export default isColorLight;
